import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { ButtonEmailRenderer } from "./email";
import { RowBlockProps } from "./types";

export default function RowWeb(props: RowBlockProps) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <ButtonEmailRenderer {...props} />
    </EmailComponentWrapper>
  );
}
